export function keyedDebounce<T extends any[]>(execFunc: (...args: T) => any, keyFunc: (...args: T) => string, timeout = 300){
    const invocationsMap:Record<string, any|undefined> = {};
    return (...args: T) => {

        const key = keyFunc.apply(this, args);
        if (invocationsMap[key]) {
            clearTimeout(invocationsMap[key].timeout);

        } else {
            invocationsMap[key] = {};
            invocationsMap[key].promise = new Promise((resolve, reject) => {
                invocationsMap[key].resolve = resolve;
                invocationsMap[key].reject = reject;
            });
        }
        invocationsMap[key].timeout = setTimeout(async () => {
            try {
                const p = execFunc.apply(this, args);

                if (p?.then) {
                  try {
                      await p;
                      invocationsMap[key].resolve();
                  } catch (e) {
                      invocationsMap[key].reject(e);
                  }
                } else {
                    invocationsMap[key].resolve();
                }
            } catch (e) {
                invocationsMap[key].reject(e);
            } finally {
                delete invocationsMap[key];
            }
        }, timeout);
        return invocationsMap[key].promise;
    };
  }